import styled from 'styled-components';

interface IPaymentTermDropdownContainer {
  minimumBilling: boolean;
  quoteNotDownloaded: boolean;
}

export const PaymentTermDropdownContainer = styled.div<IPaymentTermDropdownContainer>`
  .dropDownContent{
    display: grid;
    align-items: center;
    margin-bottom: 23px;
    grid-template-columns: 50px 195px 129px 120px;

    p{
      color: #0E4C54;
      font-size: 12px !important;
    }

    .cdName{
      strong{
        color: ${props => props.quoteNotDownloaded ? '#E02828' : '#0E4C54'};
        font-size: 14px;
      }
      span{
        color: #E02828;
      }
    }
  }

  .minimumBilling{
    display: flex;
    justify-content: right;

    p{
      color: ${props => props.minimumBilling ? '#E02828' : '#0E4C54'};
    }
  }

  .dateInputArea{
    display: flex;
    align-items: center;
    width: 130px;

    > div {
      margin-right: 10px;
    }
  }

  .customWarningIcon{
    width: 0.8rem;
    margin-right: 0.3rem;
  }

  [class*="control"]{
    min-height: 32px !important;
    border: #0E4C54 1px solid;
  }
`;

export const PaymentDeadline = styled.span`
  font-size: 10px;
  color: #E02828;
  margin-top: 4px;
  position: absolute;
`;